<script>
import { euroCouponsThirdpartyMethods } from '@state/helpers'
import {
  required,
  email,
  requiredIf,
  minLength,
  maxLength,
  maxValue,
} from 'vuelidate/lib/validators'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'EuroCouponsThirdpartyForm',
  components: { DatePicker },
  props: {
    fullform: {
      type: Boolean,
      required: false,
      default: false,
    },
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    updateJson: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    onclose: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      // modalShow: true,
      loading: true,
      submitting: false,
      action: 'create',
      photo_file: null,
      photoUrl: require('@assets/images/users/avatar-clear.png'),
      loadingPhotoUpdate: false,
      euroCouponsThirdpartyOptions: [],
      form: {
        name: null,
        nit: null,
        contact_name: null,
        contact_email: null,
        frequency: null,
        autogenerate_coupons: false,
        payment_method: null,
        prefix_code: null,
        logo: null,
      },

      masks: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['YYYY-MM-DD'], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
        data: ['YYYY-MM-DD'],
      },

      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
    }
  },
  validations() {
    let context = this
    return {
      form: {
        logo: {},
        name: { required },
        nit: { required },
        contact_name: { required },
        contact_email: { required, email },
        frequency: { required, maxValue: maxValue(31) },
        payment_method: { required },
        autogenerate_coupons: { required },
        prefix_code: {
          required: requiredIf(function () {
            return context.form.autogenerate_coupons
          }),
          minLength: minLength(4),
          maxLength: maxLength(4),
        },
      },
    }
  },
  computed: {},

  mounted: function () {
    let context = this
    context.form = {
      ...context.form,
      ...context.instanceJson,
    }
    if (context.instanceJson.url) {
      context.action = 'update'
      context.getObject()
    } else {
      context.action = 'create'
      context.loading = false
    }
  },

  methods: {
    ...euroCouponsThirdpartyMethods,

    getObject() {
      let context = this
      if (context.action == 'update') {
        const promise = context.fetchEuroCouponsThirdpartyDetail(
          context.form.url
        )
        return promise
          .then((data) => {
            context.form = { ...data }
            context.photoUrl =
              data.logo || require('@assets/images/users/avatar-clear.png')
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
          })
      }
    },

    submit() {
      let context = this
      context.submitting = true
      context.$v.form.$touch()
      if (context.$v.form.$invalid) {
        context.submitting = false
        context.$generate_toast(
          context,
          'error',
          context.$t('fill_the_required_fields')
        )
        return
      }
      let formData = new FormData()
      for (var key in context.form) {
        if (key == 'frequency') {
          formData.append(key, Number(context.form[key]))
        } else {
          formData.append(key, context.form[key])
        }
      }
      if (!context.photo_file) {
        formData.delete('logo')
      }
      const promise = context.createUpdateEuroCouponsThirdparty(formData)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `${context.$t('thirdparty')} ${
              context.action == 'create'
                ? context.$t('created')
                : context.$t('updated')
            } ${context.$t('correctly')}`
          )
          context.form = { ...data }
          delete context.form['logo']
          context.updateJson(data)
          context.action = 'update'

          setTimeout(() => {
            context.oncomplete(data.url || null)
            context.submitting = false
          }, 2000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },

    openImgInput() {
      document.getElementById('id_photo').click()
    },
    imageChanged() {
      let context = this
      // context.loadingPhotoUpdate = true
      context.photo_file = context.$refs.photo_file.files[0]
      context.form.logo = context.$refs.photo_file.files[0]
      context.photoUrl = URL.createObjectURL(context.photo_file)
      // let formData = new FormData()
      // formData.append('photo', context.photo_file)
      // context.onphotosubmit(formData).then(data=>{
      //     context.photoUrl = data.user_info.photo
      //     context.loadingPhotoUpdate = false
      // }).catch(() => {
      //     context.loadingPhotoUpdate = false
      // })
    },
  },
}
</script>

<template>
  <!-- <b-modal
    v-model="modalShow"
    :title="
      action === 'create' ? `${$t('create')} ${$t('thirdparty')}` : `${$t('update')} ${$t('thirdparty')}`
    "
    :size="action === 'create' ? 'lg' : 'lg'"
    @hidden="onclose"
    @ok.prevent="submit"
  > -->
  <b-container class="p-0">
    <b-row v-if="loading">
      <b-col md="12">
        <div class="text-center">
          <b-spinner
            label="Spinning"
            style="color: #195db2; width: 4rem; height: 4rem"
          ></b-spinner>
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="12">
        <!-- 
            Don't touch this generic form, if you need a custom form do 
            a v-else instead and code an alternative form :) 
          -->

        <b-form v-if="fullform" id="form">
          <form-wrapper :validator="$v.form">
            <div class="row">
              <b-col lg="6" sm="12">
                <div class="text-center">
                  <div
                    id="image_avatar"
                    class="user-image"
                    :style="{ backgroundImage: `url(${photoUrl})` }"
                    v-on="!loadingPhotoUpdate ? { click: openImgInput } : {}"
                  >
                    <div v-if="!loadingPhotoUpdate" class="inner-image"
                      >Change<br /><i class="fe-camera text-white"></i
                    ></div>
                    <div v-if="loadingPhotoUpdate" class="loading-inner-image">
                      Changing <br />
                      <b-spinner
                        v-if="loadingPhotoUpdate"
                        small
                        label="Spinning"
                        variant="light"
                      >
                      </b-spinner>
                    </div>
                  </div>
                  <input
                    id="id_photo"
                    ref="photo_file"
                    type="file"
                    style="display: none"
                    accept="image/jpeg,image/gif,image/png,image/bmp,image/jpg"
                    @change="imageChanged"
                  />
                  <div><b>Logo</b></div>
                </div>
                <!-- <form-group name="logo" :label="$t(`logo`)" :description="$t(`logo_help_text`)">
                    <b-form-file
                      v-model="form.logo"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group> -->

                <!-- <div class="text-center mb-2">
                    <div
                      id="image_avatar"
                      class="user-image"
                      :style="{ backgroundImage: `url(${photoUrl})` }"
                      v-on="!loadingPhotoUpdate ? { click: openImgInput } : {}"
                      >
                      <div v-if="!loadingPhotoUpdate" class="inner-image">Change<br><i class="fe-camera text-white"></i></div>
                      <div v-if="loadingPhotoUpdate" class="loading-inner-image" >
                          Changing <br>
                          <b-spinner
                          v-if="loadingPhotoUpdate"
                          small
                          label="Spinning"
                          variant="light"
                          >
                          </b-spinner>
                      </div>
                    </div>
                    <input
                        id="id_photo"
                        ref="photo_file"
                        type="file"
                        style="display: none;"
                        accept="image/jpeg,image/gif,image/png,image/bmp,image/jpg"
                        @change="imageChanged"
                    />
                    <div><b>Avatar</b></div>
                  </div> -->

                <form-group name="name" :label="$t(`name`)">
                  <b-form-input
                    class="border-primary"
                    type="text"
                    v-model="form.name"
                    slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                  />
                </form-group>

                <form-group
                  name="nit"
                  :label="$t(`nit`)"
                  :description="$t(`nit_help_text`)"
                >
                  <b-form-input
                    class="border-primary"
                    type="number"
                    v-model="form.nit"
                    slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                  />
                </form-group>
                <form-group
                  name="payment_method"
                  :label="$t(`payment_method`)"
                  :description="$t(`payment_method_help_text`)"
                >
                  <b-form-input
                    class="border-primary"
                    type="text"
                    v-model="form.payment_method"
                    slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                  />
                </form-group>
              </b-col>

              <b-col lg="6" sm="12">
                <form-group
                  name="contact_name"
                  :label="$t(`contact_name`)"
                  :description="$t(`contact_name_help_text`)"
                >
                  <b-form-input
                    class="border-primary"
                    type="text"
                    v-model="form.contact_name"
                    slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                  />
                </form-group>

                <form-group
                  name="contact_email"
                  :label="$t(`contact_email`)"
                  :description="$t(`contact_email_help_text`)"
                >
                  <b-form-input
                    class="border-primary"
                    type="email"
                    v-model="form.contact_email"
                    slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                  />
                </form-group>

                <!-- {{form.payment_due_date}} -->
                <form-group
                  name="frequency"
                  :label="$t(`payment_due_date`)"
                  :description="$t(`payment_due_date_help_text`)"
                >
                  <b-form-input
                    class="border-primary"
                    type="number"
                    v-model="form.frequency"
                    :formatter="(value) => Number(value)"
                    slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                  />
                </form-group>
                <!-- <b-form-group name="payment_due_date" :label="$t(`payment_due_date`)">
                    <DatePicker v-model="form.payment_due_date" class="inline-block h-full" :mask="masks" :model-config="modelConfig">
                      <template v-slot="{ inputValue, togglePopover }">
                        <div class="flex items-center">
                          <b-input-group>
                            <b-form-input
                            class=" rounded-lg border-primary" 
                            :value="inputValue" />
                            <b-input-group-append>
                              <b-button
                                variant="outline-primary"
                                class="ml-1 rounded-lg"
                                @click="togglePopover"
                              >
                                <i class="far fa-calendar-alt font-17"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </div>
                      </template>
                    </DatePicker>
                  </b-form-group> -->
                <!-- <b-form-group name="payment_due_date" :label="$t(`payment_due_date`)" :description="$t(`payment_due_date_help_text`)">
                    <VueCtkDateTimePicker
                      v-model="form.payment_due_date"
                      id="payment_due_date"
                      format="YYYY-MM-DDTHH:mm:ss.sssZ"
                    />
                  </b-form-group>  -->
                <form-group
                  name="autogenerate_coupons"
                  :description="$t(`autogenerate_coupons_help_text`)"
                >
                  <b-form-checkbox
                    v-model="form.autogenerate_coupons"
                    :disabled="action === 'update'"
                    name="check-button"
                    switch
                  >
                    {{ $t(`autogenerate_coupons`) }}
                  </b-form-checkbox>
                  <!-- <b-form-input
                      class="border-primary"
                      type="text"
                      v-model="form.autogenerate_coupons"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    /> -->
                </form-group>
                <form-group
                  v-if="form.autogenerate_coupons"
                  name="prefix_code"
                  :label="$t(`prefix_code`)"
                  :description="$t(`prefix_code_help_text`)"
                >
                  <b-form-input
                    class="border-primary"
                    type="text"
                    :disabled="action === 'update'"
                    v-model="form.prefix_code"
                    :formatter="(value) => value.toUpperCase()"
                    slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                  />
                </form-group>
              </b-col>
            </div>
            <div>
              <!-- <form-summary /> -->
            </div>
          </form-wrapper>
          <div class="text-right">
            <b-button
              class="rounded-lg"
              variant="primary"
              :class="{ disabled: submitting }"
              @click="submit"
            >
              <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
              <span v-if="submitting"> {{ $t('saving') }} </span>
              <span v-else>
                <i class="fe-save"></i>
                {{ $t('save') }}
              </span>
            </b-button>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </b-container>

  <!-- <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> {{ $t('saving') }} </span>
        <span v-else>
          <i class="fe-save"></i>
           {{ $t('save') }}
        </span>
      </b-button>
    </template> -->
  <!-- </b-modal> -->
</template>
<style lang="scss">
.user-image {
  display: inline-block;
  z-index: 5;
  height: 140px;
  width: 140px;
  border: 1px solid #0570a7;
  box-shadow: 0px 0px 2px 2px rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  background-size: cover;
  background-position: top center;
  overflow: hidden;
  /*background-image: url('');*/
}
.user-image:hover .inner-image {
  background-color: rgb(0, 0, 0, 0.4);
  display: block;
}
.user-image .inner-image {
  display: none;
  cursor: pointer;
  color: white;
  width: 100%;
  height: 100%;
  font-size: 15px;
  text-align: center;
  padding-top: 46px;
  font-weight: bolder;
  line-height: 1.2;
}
.user-image .inner-image i {
  font-size: 20px;
}

.user-image .loading-inner-image {
  background-color: rgb(0, 0, 0, 0.4);
  cursor: not-allowed;
  color: white;
  width: 100%;
  height: 100%;
  font-size: 15px;
  text-align: center;
  padding-top: 46px;
  font-weight: bolder;
  line-height: 1.2;
}
.user-image .loading-inner-image i {
  font-size: 20px;
}
</style>